import Footnotes from "./footnotes/footnotes";
import FootnoteReference from "./footnotes/reference";
import Footnote from "./footnotes/footnote";

export { Footnotes, Footnote, FootnoteReference };
